export default (_context, inject) => {
  inject('getFingerprint', async () => {
    const FingerprintJS = await import('@fingerprintjs/fingerprintjs')
    return await FingerprintJS.load()
  })
}
